/**
 * The reCAPTCHA key and script the site runs, and the browser object they
 * give us.
 *
 * Since 2026-10-18 this is a reCAPTCHA Enterprise key in the Cloud project
 * `sellwild`: the page loads enterprise.js and mints tokens with
 * `grecaptcha.enterprise.execute`. The classic key it replaced (6Lc3xNIt...,
 * still in NEXT_PUBLIC_RECAPTCHA_SITE_KEY) had returned no scores since
 * 2026-10-07. A site key is public; it ships in every page.
 */
export const RECAPTCHA_SITE_KEY =
	process.env.NEXT_PUBLIC_RECAPTCHA_ENTERPRISE_SITE_KEY || '6Le6o_QtAAAAAF9jMK--iB75On2kYrAM3i1GuhLl';

export const RECAPTCHA_SCRIPT_URL = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;

/** What enterprise.js puts on `window.grecaptcha.enterprise`, as far as we use it. */
export interface RecaptchaClient {
	execute?: (siteKey: string, options: { action: string }) => Promise<string>;
	ready?: (callback: () => void) => void;
	/** Draws a checkbox widget for another key into `container` (components/BotChallengeHost.tsx). */
	render?: (
		container: HTMLElement,
		params: {
			sitekey: string;
			callback: (token: string) => void;
			'expired-callback'?: () => void;
			'error-callback'?: () => void;
		}
	) => number;
}

/** The Enterprise client, or undefined before enterprise.js has run (or on the server). */
export function recaptchaClient(): RecaptchaClient | undefined {
	if (typeof window === 'undefined') return undefined;
	const grecaptcha = (window as unknown as { grecaptcha?: { enterprise?: RecaptchaClient } }).grecaptcha;
	return grecaptcha?.enterprise ?? undefined;
}
